import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import { ROUTES } from '../routes'

interface PermissionGuardProps {
  children: React.ReactNode
  permission?: string
  role?: string
  fallback?: React.ReactNode
}

export function PermissionGuard({
  children,
  permission,
  role,
  fallback = <Navigate to={ROUTES.DASHBOARD} replace />,
}: PermissionGuardProps) {
  const { hasPermission, hasRole, isLoading, _hasHydrated } = useAuthStore()

  // Attendre l'hydratation du store avant de décider
  if (isLoading || !_hasHydrated) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '200px',
        }}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: '2px solid var(--bd)',
            borderTopColor: 'var(--brand-orange)',
            animation: 'spin .7s linear infinite',
          }}
        />
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      </div>
    )
  }

  if (permission && !hasPermission(permission)) return <>{fallback}</>
  if (role && !hasRole(role)) return <>{fallback}</>

  return <>{children}</>
}
